import { useMemo } from 'react';

import { useIsAskMeAnythingEnabled, useIsQuestionsOnlyMode } from '../../featureChecks';
import type { UseMainUIFeatureSettings } from '../../types';
import { uiFeatureAccessSymbol } from '../../types';

export const useAskMeAnythingEventEditingPageSettings: UseMainUIFeatureSettings<'askMeAnythingEventEditingPage'> = (
  options
) => {
  const askMeAnythingEventEditingPageOverrides = options?.overrides?.askMeAnythingEventEditingPage;

  const isAMAEnabled = useIsAskMeAnythingEnabled();
  const isQuestionsOnlyMode = useIsQuestionsOnlyMode();

  return useMemo(() => {
    if (isQuestionsOnlyMode) {
      return {
        [uiFeatureAccessSymbol]: false,
        ...askMeAnythingEventEditingPageOverrides,
      };
    }

    return {
      [uiFeatureAccessSymbol]: isAMAEnabled,
      ...askMeAnythingEventEditingPageOverrides,
    };
  }, [askMeAnythingEventEditingPageOverrides, isAMAEnabled, isQuestionsOnlyMode]);
};
